import { createSlice } from "@reduxjs/toolkit";
import { inputPropertyType, stateType, Features, InputProperty } from "./models/models"

const initialState: stateType = {
  searchedText: "",
  category: null,
  generalInfo: {
    isShowNonOriginalProduct: new InputProperty(true, false),
    isIranianProduct: new InputProperty(true, false),
    productModel: new InputProperty(true, ""),
    brandDropdown: new InputProperty(true, null),
    lengthOfPackage: new InputProperty(true, ""),
    widthOfPackage: new InputProperty(true, ""),
    heightOfPackage: new InputProperty(true, ""),
    weightOfPackage: new InputProperty(true, ""),
    productDescription: new InputProperty(true, "")
  },
  features: [],
  title: {
    persianName: new InputProperty(true, ""),
    englishName: new InputProperty(false, "")
  },
  attachments: {},
  isShowStepTwoValidation: false,
  isShowStepThreeValidation: false,
  isShowStepFourValidation: false,
  isShowStepFiveValidation: false
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const productSlice = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    searchedTextSet: (state, action) => {
      state.searchedText = action.payload;
    },
    searchedTextReset: (state, action) => {
      state.searchedText = "";
    },

    //Category
    categorySet: (state, action) => {
      state.category = action.payload;
    },
    categoryReset: (state, action) => {
      state.category = null;
    },

    //GeneralInfo
    generalInfoSet: (state, action) => {
      const { event, nameOfField, value } = action.payload;
      let generalInfo = state.generalInfo[nameOfField as keyof InputProperty];
      state.generalInfo[nameOfField as keyof InputProperty] = new InputProperty(generalInfo.isRequired, value);
    },

    //Features
    featureSet: (state, action) => {
      const { event, key, value } = action.payload;
      let find = state.features.find(i => i.key === key);
      let index = state.features.indexOf(find!);
      if (index != -1) {
        state.features.splice(index, 1);
      }
      state.features.push(new Features(key, value));
    },

    //title
    titleSet: (state, action) => {
      const { event, nameOfField, value } = action.payload;
      let title = state.title[nameOfField as keyof InputProperty];
      state.title[nameOfField as keyof InputProperty] = new InputProperty(title.isRequired, value);
    },
    //title
    stepTwoValidationSet: (state, action) => {
      
      state.isShowStepTwoValidation = action.payload;
    },

    stepThreeValidationSet: (state, action) => {
      state.isShowStepThreeValidation = action.payload;
    },

    stepFourValidationSet: (state, action) => {
      state.isShowStepFourValidation = action.payload;
    },

    stepFiveValidationSet: (state, action) => {
      state.isShowStepFiveValidation = action.payload;
    }
  }
});
